import classNames from "classnames";
import Skeleton from "react-loading-skeleton";
import { formatToCurrency, formatToNumber } from "../../helperFunctions";
import {
  SKELETON_BASE_COLOR,
  SKELETON_HIGHLIGHT_COLOR,
} from "../../utils/constants";
import { Icon } from "../icons/icon";

export const DashboardCard = ({
  title,
  value,
  changeValue,
  changeType,
  changeText = "vs last month",
  currency = "NGN",
  loading = false,
  className = "",
  iconClassName = "",
  icon = "coins",
}: {
  title: string;
  value: number;
  changeValue: number;
  changeType: "increment" | "decrement";
  changeText?: string;
  currency?: string;
  loading?: boolean;
  className?: string;
  iconClassName?: string;
  icon?: string;
}) => {
  return (
    <div
      className={classNames(
        "p-5 rounded-xl border border-pry-dark-green-300/10 flex gap-4 items-start",
        className
      )}
    >
      <div
        className={classNames(
          "max-w-[40px] max-h-[40px] p-2.5 rounded-lg",
          iconClassName
        )}
      >
        <Icon className={""} svg={icon} width={20} height={20} />
      </div>

      <div className="flex-1">
        <div className="flex items-center justify-between">
          {loading ? (
            <>
              <Skeleton
                baseColor={SKELETON_BASE_COLOR}
                highlightColor={SKELETON_HIGHLIGHT_COLOR}
                height={24}
                width={50}
                containerClassName="!h-fit"
                className="opacity-30"
              />

              <Skeleton
                baseColor={SKELETON_BASE_COLOR}
                highlightColor={SKELETON_HIGHLIGHT_COLOR}
                height={20}
                width={80}
                containerClassName="!h-fit"
                className="opacity-30"
              />
            </>
          ) : (
            <>
              <p className="text-pry-dark-green-400 font-bold text-sm md:text-base">
                {title}
              </p>

              <p
                className={classNames(
                  "flex items-center gap-0.5 text-xs md:text-sm font-medium",
                  {
                    "text-success-600": changeType === "increment",
                    "text-error-600": changeType === "decrement",
                  }
                )}
              >
                <Icon
                  svg="arrow-up"
                  width={16}
                  height={16}
                  className={classNames({
                    "text-success-sec": changeType === "increment",
                    "text-error-sec rotate-180": changeType === "decrement",
                  })}
                />
                {formatToNumber(changeValue, {
                  style: "percent",
                  decimalPlaces: 0,
                })}{" "}
                <span className="text-text-tertiary">{changeText}</span>
              </p>
            </>
          )}
        </div>

        {loading ? (
          <Skeleton
            baseColor={SKELETON_BASE_COLOR}
            highlightColor={SKELETON_HIGHLIGHT_COLOR}
            height={38}
            width={"100%"}
            className="mt-2 opacity-30"
          />
        ) : (
          <p className="text-pry-dark-green-400 font-bold mt-2 text-2xl md:text-3xl tracking-normal">
            {formatToCurrency(value, { currency: currency, decimalPlaces: 2 })}
          </p>
        )}
      </div>
    </div>
  );
};
